<!--
  A picture of the request card a mentor sees when a member asks to talk
  (IncomingTalkRequest.vue). It shows an example request and does nothing.
-->
<template>
  <div
    class="rounded-2xl bg-neutral-50 px-4 py-5 sm:px-6 sm:py-6"
    aria-hidden="true"
  >
    <div
      class="mx-auto max-w-[330px] rounded-[20px] bg-white p-[18px] text-left shadow-[0_14px_34px_rgba(20,31,47,0.16)]"
    >
      <p class="text-success-700 mb-3 text-xs font-semibold">
        Someone wants to talk now
      </p>
      <div class="flex items-center gap-2.5">
        <img
          src="/avatars/male/3.png"
          alt=""
          width="40"
          height="40"
          class="size-10 shrink-0 rounded-full bg-neutral-100 object-cover"
        />
        <div class="min-w-0 flex-1">
          <div class="truncate text-sm font-semibold text-neutral-900">
            Marcus Webb
          </div>
          <div class="truncate text-[11px] text-neutral-500">
            Founder, seed-stage fintech
          </div>
        </div>
        <span
          class="bg-success-50 text-success-800 shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold tabular-nums"
        >
          1:24
        </span>
      </div>
      <p
        class="mt-2.5 rounded-[10px] bg-neutral-50 px-2.5 py-2 text-xs text-neutral-800"
      >
        Our paid social CAC doubled in a month. Where do I look first?
      </p>
      <div class="mt-3.5 flex gap-2 text-xs font-medium">
        <span
          class="flex flex-1 items-center justify-center rounded-full border border-[#E0E3EA] py-[7px] text-neutral-500"
        >
          Not now
        </span>
        <span
          class="bg-success-500 border-success-500 flex flex-1 items-center justify-center gap-1.5 rounded-full border py-[7px] text-white"
        >
          <VideoIcon class="size-3.5" />
          Join the call
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VideoIcon from '~icons/lucide/video'
</script>
